import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ImgPlaceHolder from '../../constant/imgPlaceholder';
import { dashboardAction } from '../../redux/action';
import { ROUTE } from '../../route/Route';
import BreadCrumb from '../breadcrumb/BreadCrumb'
import WaitScreen from '../LodingScreen/WaitScreen';
import SeoAdd from '../Seo/SeoAdd';
import SubmitForm from '../SubmitForm/SubmitForm';
import { useTranslation } from "react-i18next";

const Ecme = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [imgUri, setImgUri] = useState<string>("");
    const [videoUri, setVideoUri] = useState<string>("");
    const [cme, setCme] = useState<any>([]);
    const cmeData:any = useSelector((state:any) => state.dashboard.cme ? state.dashboard.cme : {});

    useEffect(() => {
        window?.scrollTo(0, 0);
        dispatch(dashboardAction.cmeListAction({}));
        return () => {};
    }, []);

    useEffect(() => {
        setImgUri(cmeData?.ImageBaseUrl);
        setVideoUri(cmeData?.VideoBaseUrl)
        setCme(cmeData?.CMELists);
        return () => {};
    }, [cmeData]);
    return (
    <>
    <SeoAdd slug={ROUTE.ECME}/>
        <BreadCrumb page={"eCME"} data={{slug: "", path: ""}}/> 
        {cmeData && Object.keys(cmeData).length >0 ?
        <>
        <section className="about-section">
              <div className="container" id="section2">
                <div className="row">
                    <div className="col-md-12">
                        <div className="overview-wrap text-center">
                            <img src="/assets/img/ecme_banner.png" className="scale" alt="" />
                            <div className="headingmains text-center pb-3">
                                <h1 className="right aos-init pb-2 mt-sm-4 mt-lg-5">Electronic Continuing Medical Education</h1>
                            </div>
                            <p className="text-center dull_heading pb-3">We bring together healthcare professionals to share information on relevant topics</p>
                        </div>
                    </div>
                </div>          
            </div>
        </section>
        <section className="news_section pb-4">
            <div className="container">
                <div className="row"> 
                    {cme && cme.length > 0 ? cme?.map((item:any, i:any)=> (
                        <div className="col-md-4" key={i}>
                            <div className="news_img col-md-12"><img src={item?.Images && item?.Images.length>0 && imgUri ?  `${imgUri}${item?.Images[0]?.image}` : "/assets/img/histopathology.jpg"} onError={(e:any)=> ImgPlaceHolder(e, "/assets/img/histopathology.jpg")} className="scale round_img" alt="" /></div>
                            <div className="col-md-12 box-white-shadow news_box_width_85">
                            <div className="infobox_wrapper">
                                <h5 className="mb-3">{item?.EventTitle}</h5>
                                <div className="f-14">{item?.ShortDetails && item?.ShortDetails?.slice(0,300)}</div>
                                <Link className="infobox_button button-read-more" to={`${ROUTE.ECME}/${item?.Slug}`}><img src="/assets/img/arrow-read.svg" className="scale" /></Link>
                            </div>
                        </div>
                    </div>
                    ))
                    : 
                    (<p className="col-md-12 f-20 text-center">{t("no_cme_available")}</p>)
                    }
                </div>
            </div>
        </section>
        <SubmitForm heading={t("reach_out-to_us")} des={""} PageSrc={"Ecme"}/>
        </>
        : <WaitScreen/>
        }
     </>
    )
}

export default Ecme